//Magasin pour stocker le message de chargement

import { ref } from "vue";
import { defineStore } from "pinia";

export const useDialogStore = defineStore("dialog", () => {
	//Variables pour le loader
	const isLoading = ref(); //indique si le loader est affiché ou non
	//Variables pour le toast
	const isToastVisible = ref(false); //indique si le toast est affiché ou non
	const toastMessage = ref(""); //message du toast
	const toastClosable = ref(true); //indique si le toast est fermable ou non
	const toastType = ref<
		"none" | "success" | "error" | "warning" | "info" | undefined
	>("info"); //type du toast (success, error, warning, info)
	//Variables pour le message d'avertissement
	const alertMsgDialogText = ref();
	const alertMsgOkBtnText = ref();
	const alertMsgDialogVisible = ref();
	const isOK = ref(false);
	const asResponded = ref(false);
	const loaderMsg = ref("");
	const isBackdropShowed = ref(false);
	const sideMenuIndex = ref(0);
	const logoutModal = ref(false);

	//========= Fionctions pour le loader =========//
	/**
	 * Affiche ou cache le loader
	 * @param value
	 */
	function Load(value: boolean) {
		isLoading.value = value;
	}

	function SetMsg(msg: string) {
		loaderMsg.value = msg;
	}

	//========= Fionctions pour le toast =========//
	/**
	 * Affiche un toast permanent, il faut le fermer manuellement
	 * @param msg
	 * @param type
	 */
	function ToastSticky(
		msg: string,
		type: "none" | "success" | "error" | "warning" | "info" | undefined
	) {
		isToastVisible.value = true;
		toastMessage.value = msg;
		toastType.value = type;
		toastClosable.value = true;
	}
	/**
	 *
	 * @param msg Affiche un toast qui se ferme automatiquement au bout de 3 secondes
	 * @param type
	 */
	function Toast(
		msg: string,
		type: "none" | "success" | "error" | "warning" | "info" | undefined
	) {
		isToastVisible.value = true;
		toastMessage.value = msg;
		toastType.value = type;
		toastClosable.value = false;
		setTimeout(() => {
			isToastVisible.value = false;
		}, 3000);
	}

	//========= Fionctions pour le message d'avertissement =========//
	/**
	 * Affiche un message d'avertissement
	 * @param text
	 * @param action
	 * @param obj
	 * @param okBtnText
	 */
	function AlertMsgDialog(text: string, okBtnText: string) {
		alertMsgDialogText.value = text;
		alertMsgOkBtnText.value = okBtnText;
		isOK.value = false;
		alertMsgDialogVisible.value = true;
		console.log("msg en attente de réponse");

		//return dialogPromise();
		// console.log("réponse recue");
		// asResponded.value = false;
	}

	function ToggleAlertMsgDialog() {
		alertMsgDialogVisible.value = !alertMsgDialogVisible.value;
	}

	function okPressed() {
		isOK.value = true;
		asResponded.value = true;
		alertMsgDialogVisible.value = false;
	}

	function cancelPressed() {
		isOK.value = false;
		asResponded.value = true;
		alertMsgDialogVisible.value = false;
	}

	function ShowBackdrop(show: boolean) {
		isBackdropShowed.value = show;
	}

	function setSideMenu(item: number) {
		sideMenuIndex.value = item;
	}

	function showLogout() {
		logoutModal.value = true;
	}

	return {
		isLoading,
		Load,
		ToastSticky,
		isToastVisible,
		Toast,
		toastMessage,
		toastType,
		toastClosable,
		alertMsgDialogVisible,
		ToggleAlertMsgDialog,
		alertMsgDialogText,
		alertMsgOkBtnText,
		okPressed,
		isOK,
		asResponded,
		cancelPressed,
		AlertMsgDialog,
		SetMsg,
		loaderMsg,
		ShowBackdrop,
		isBackdropShowed,
		setSideMenu,
		sideMenuIndex,
		showLogout,
		logoutModal,
	};
});
